// LÒpez => Lopez
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
export var accentFold = function accentFold() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};